import { CustomerContactPreference, NotificationSettings } from '../dataModels/models';

type CustomerContactDetails = {
  summary: string;
  instruction: string;
};

const trimOptional = (value?: string | null) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

type CustomerContactBusiness = {
  notificationSettings?: Pick<
    NotificationSettings,
    'customerContactPreference' | 'customerContactEmail' | 'customerContactPhone'
  > | null;
};

export function getBusinessCustomerContactDetails(
  business?: CustomerContactBusiness | null,
): CustomerContactDetails | null {
  const notificationSettings = business?.notificationSettings;
  if (!notificationSettings) {
    return null;
  }

  const contactEmail = trimOptional(notificationSettings.customerContactEmail);
  const contactPhone = trimOptional(notificationSettings.customerContactPhone);

  switch (notificationSettings.customerContactPreference) {
    case CustomerContactPreference.EMAIL:
      return contactEmail
        ? {
          summary: contactEmail,
          instruction: `Questions about your appointment? Email ${contactEmail}.`,
        }
        : null;
    case CustomerContactPreference.PHONE:
      return contactPhone
        ? {
          summary: contactPhone,
          instruction: `Questions about your appointment? Call or text ${contactPhone}.`,
        }
        : null;
    case CustomerContactPreference.BOTH:
      return contactEmail && contactPhone
        ? {
          summary: `${contactEmail} or ${contactPhone}`,
          instruction: `Questions about your appointment? Email ${contactEmail} or call/text ${contactPhone}.`,
        }
        : null;
    default:
      return null;
  }
}
